import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { ListTitleService } from '../services/list-title.service';
import { CategoryUnitService } from '../services/category-unit.service';

@Component({
  selector: 'app-category-unit',
  templateUrl: './category-unit.component.html',
  styleUrls: ['./category-unit.component.css'],
})
export class CategoryUnitComponent
  extends SecondPageIndexBase
  implements OnInit
{
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: CategoryUnitService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'stt',
        header: 'Số thứ tự',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'unitCode',
        header: 'Mã đơn vị',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'unitName',
        header: 'Tên đơn vị',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'notes',
        header: 'Ghi chú',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      code: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize,
    };

    this._service
      .getCategoryUnit(model)
      .then((res) => {
        if (res) {
          this.dataSource = res.data;
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }
  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
